<template>
  <div class="account-manage">
    <div class="account-title">
      角色管理
      <el-button icon="el-icon-folder-opened" @click="addRole" size="mini">新增</el-button>
    </div>
    <div class="account-table">
      <el-table :data="roleModel.tableData" height="753px" border>
        <el-table-column type="selection" min-width="10" align="center"></el-table-column>
        <el-table-column label="角色名称" prop="Name" min-width="200" align="center"></el-table-column>
        <el-table-column label="角色类型" prop="Type" min-width="100" align="center"></el-table-column>
        <el-table-column label="角色状态" prop="Status" min-width="80" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Status | keyToVal(statusType)"
              effect="dark"
              size="small"
            >{{scope.row.Status | keyToVal(normalStatus)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户数量" prop="Count" min-width="80" align="center">
          <template slot-scope="scope">
            <el-button @click="viewRoleMember(scope.row.Id)">{{scope.row.Count}}</el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-row type="flex" class="row-bg" justify="space-around">
              <el-button
                size="mini"
                type="primary"
                v-on:click.stop="openRoleDialog(scope.row)"
                v-if="scope.row.Status === 0">编辑
              </el-button>
               <el-button-group>
                 <el-button
                  v-if="scope.row.Status === 0"
                  size="mini"
                  type="warning"
                  @click="changeState(scope.row.Id, 1)"
                  >禁用</el-button>
                <el-button
                  v-if="scope.row.Status === 1"
                  size="mini"
                  type="success"
                  @click="changeState(scope.row.Id, 0)"
                  >启用</el-button >
                  <el-popconfirm title="确认删除吗？"  v-on:onConfirm="changeState(scope.row.Id, -1)">
                    <el-button size="mini" type="danger" slot="reference">删除</el-button>
                  </el-popconfirm>
              </el-button-group>
              <!-- <el-popconfirm title="确认删除吗？" v-on:onConfirm="deleteRole(scope.row.Id)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm> -->
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑/查看角色模态框 -->
    <el-dialog
      title="角色管理"
      :visible.sync="roleModel.dialog"
      @close="resetForm('roleForm')"
      :close-on-click-modal="false"
    >
      <el-form :model="roleModel.form" :rules="roleModel.rules" ref="roleForm" label-width="120px">
        <el-form-item prop="RoleName" label="角色名称">
          <el-input v-model="roleModel.form.RoleName"></el-input>
        </el-form-item>
        <el-form-item prop="Type" label="角色类型">
          <el-input v-model="roleModel.form.Type"></el-input>
        </el-form-item>
        <el-form-item label="角色权限">
          <el-tree
            :data="menuTree"
            show-checkbox
            node-key="Id"
            ref="menuTree"
            check-strictly
            highlight-current
            :props="{children: 'Children',label: 'Name'}"
          ></el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="roleModel.dialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('roleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增/编辑/查看角色用户模态框 -->
    <el-dialog title="角色所属用户查看" :visible.sync="memberModel.dialog" :close-on-click-modal="false">
      <el-table :data="memberModel.tableData" border height="550px">
        <el-table-column type="selection" min-width="20"></el-table-column>
        <el-table-column label="用户名" prop="UName" min-width="140" align="center"></el-table-column>
        <el-table-column label="用户昵称" prop="NickName" min-width="140" align="center"></el-table-column>
        <el-table-column label="所属总店" prop="Company" min-width="140" align="center"></el-table-column>
        <el-table-column label="所属门店" prop="Store" min-width="140" align="center"></el-table-column>
       
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { keyToVal } from "@/filters/filters";
import COMMON from "@/api/common";
export default {
  name: "AccountManage",
  data() {
    return {
      roleModel: {
        dialog: false,
        type: "",
        form: {
          Id: "",
          RoleName: "",
          Type: "",
          SubMenu: [], //角色权限
        },
        rules: {
          RoleName: [
            { required: true, message: "请输入角色名", trigger: "blur" },
          ],
          Type: [
            { required: true, message: "请输入角色类型", trigger: "blur" },
          ],
        },
        tableData: [{ Name: "", Type: "", Status: 0, Count: 0 }],
      },
      memberModel: {
        dialog: false,
        tableData: [
          {
            Uname: "",
            NickName: "",
          },
        ],
      },
      menuTree: [],
    };
  },
  inject: ["deepClone"],
  computed: {
    ...mapState("common", ["normalStatus", "statusType"]),
  },
  filters: {
    keyToVal,
  },
  methods: {
    MenuChecked(a, b, c){
      if (b) {
          this.$refs.menuTree.setChecked(a.pid, true, false);
      } else {
          for (var i in a.children) {
              this.$refs.menuTree.setChecked(a.children[i].id, false, true);
          }
      }
    },
    //打开查看/编辑模态框
    async openRoleDialog(role) {
      this.roleModel.dialog = true;
      this.roleModel.type = "edit";
      this.roleModel.form.RoleName = role.Name;
      this.roleModel.form.Type = role.Type;
      this.roleModel.form.Id = role.Id;
      await this.$nextTick(); //ref不是响应式的

      COMMON.getRoleMenus(role.Id).then((res) => {
        if (res.status === "success") {
          this.$refs.menuTree.setCheckedKeys(res.content);
        } else {
          this.$message.error("权限获取失败");
        }
      });
    },
    //打开新增模态框
    addRole() {
      this.roleModel.dialog = true;
      this.roleModel.type = "add";
    },
    getMenuTree() {
      COMMON.getMenuTree().then((res) => {
        if (res.status === "success") {
          this.menuTree = res.content;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //提交模型
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === "roleForm") {
            if (this.roleModel.type === "add") {
              this.roleModel.form.SubMenu = this.$refs.menuTree.getCheckedKeys();
              COMMON.addRole(this.roleModel.form).then((res) => {
                if (res.status === "success") {
                  this.$message.success("添加成功");
                  this.roleModel.dialog = false;
                  this.getRoles();
                } else {
                  this.$message.error(res.msg);
                  return;
                }
              });
            } else if (this.roleModel.type === "edit") {
              this.roleModel.form.SubMenu = this.$refs.menuTree.getCheckedKeys();
              COMMON.updateRole(this.roleModel.form).then((res) => {
                if (res.status === "success") {
                  this.$message.success("修改成功");
                  this.roleModel.dialog = false;
                  this.getRoles();
                } else {
                  this.$message.error(res.msg);
                  return;
                }
              });
            }
          }
        } else {
          this.$message.error("请补全信息");
        }
      });
    },
    resetForm(formName) {
      if (formName === "roleForm") {
        this.roleModel.form = {
          RoleName: "",
          Type: "",
          SubMenu: [], //角色权限
          // Count: 0,
          // Status: 0,
        };
        this.$refs.menuTree.setCheckedKeys([]);
      }
      this.$refs[formName].clearValidate();
      // this.$refs[formName].resetFields();
    },
    disableForm(formName) {
      this.$refs[formName].resetFields();
    },
    //远程模糊搜索用户姓名
    remoteMember() {},
    exportTable() {},
    viewRoleMember(roleId) {
      COMMON.getRoleMembers(roleId).then((res) => {
        if (res.status === "success") {
          this.memberModel.tableData = res.content.map((v) => {
            return {
              NickName: v.NikeName,
              UName: v.Uname,
              Company: v.Company ? v.Company.Name : "",
              Store: v.Store ? v.Store.Name : "",
            };
          });
          this.memberModel.dialog = true;
        } else {
          this.$message.error("数据获取失败");
        }
      });
    },
    deleteRole(Id) {
      COMMON.deleteRole({ Id }).then((res) => {
        if (res.status === "success") {
          this.$message.success("删除成功");
          this.getRoles();
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    updateRoleMember() {},
    //获取角色列表
    getRoles() {
      COMMON.getRoles().then((res) => {
        if (res.status === "success") {
          this.roleModel.tableData = res.content;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
     //禁用，启用，删除
    changeState(Id, Status) {
      COMMON.changeRoleState({ Id, Status }).then((res) => {
        if (res.status === "success") {
          this.$message.success("操作成功");
          this.getRoles();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  
  },
  created() {
    this.getRoles();
    this.getMenuTree();
  },
};
</script>
<style scoped lang="less">
.account-manage .account-title {
  height: 45px;
  padding: 5px 20px;
  background: #efefef;
  border-bottom: 1px solid #ddd;
}

.account-manage .account-table {
  height: 753px;
}
.account-manage .account-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
